import { entityEndpointMap } from 'base/constants/endpoints';
import { apiAction } from 'base/utils/apiHelpers';
import {
  FETCH_REQUEST,
  FETCH_SUCCESS,
  FETCH_FAILURE
} from 'base/actions/actionTypes';

export const fetchSingleEntity = (entityType, endpoint) => {
  const entityEndpoint = endpoint || entityEndpointMap[entityType];
  const types = [
    { type: `[${entityType}] ${FETCH_REQUEST}` },
    {
      type: `[${entityType}] ${FETCH_SUCCESS}`,
      meta: { lastFetched: Date.now() }
    },
    { type: `[${entityType}] ${FETCH_FAILURE}` }
  ];

  return apiAction(entityEndpoint, 'GET', types);
};
